<template>
    <VideoCard :video="mappingTrainingInfo" isTopRated isSupplier />
</template>

<script>
import VideoCard from '../videos/VideoCard.vue'

export default {
  name: 'TrainingCard',
  components: {
    VideoCard
  },
  props: {
    trainingInfo: {
      default: 'all'
    }
  },
  computed: {
    mappingTrainingInfo () {
      return {
        title: this.trainingInfo.training_name,
        description: this.trainingInfo.description,
        video_id: this.trainingInfo.video_id,
        category: this.trainingInfo.category,
        video_rating: this.trainingInfo.video_rating,
        cta_external_link: this.trainingInfo.cta_external_link,
        // eslint-disable-next-line max-len
        thumbnail: this.trainingInfo.featured_image ? this.convertSingleQuotesToObject(this.trainingInfo.featured_image) : null,
        // eslint-disable-next-line max-len
        media_link: this.trainingInfo.media_link ? this.convertSingleQuotesToObject(this.trainingInfo.media_link) : null
      }
    }
  },
  methods: {
    convertSingleQuotesToObject (str) {
      return JSON.parse(str.replace(/'/g, '"'))
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">

</style>
